import api from "../api"

export const riskmatrixAPI = {
	async getAll(Status) {
		let value = await api.get(`/riskmatrix/`, { params: { Status: Status } })
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	}, async getCount() {
		let value = await api.get(`/riskmatrixcount/`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	}, async createRisk(Title, Owner, Description, Year, Status) {
		console.log("In API " + Year)
		let value = await api.post(`/riskmatrix/`, {
			Title: Title,
			Owner: Owner,
			Description: Description,
			Year: Year,
			Status: Status
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	}, async getRiskMatrixById(ID) {
		if (isNaN(parseInt(ID))) {
			throw Error("ID must be a number")
		}
		let value = await api.get(`/riskmatrix/${ID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	}, async updateRiskById(ID, Title, Owner, Description, Year, Status, Comment) {
		if (isNaN(parseInt(ID))) {
			throw Error("ID must be a number")
		}
		let value = await api.put(`/riskmatrix/${ID}`, {
			Title: Title,
			Owner: Owner,
			Description: Description,
			Year: Year,
			Status: Status,
			Comment: Comment
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	}, async deleteRisk(ID) {
		if (isNaN(parseInt(ID))) {
			throw Error("ID must be a number")
		}
		let value = await api.delete(`/riskmatrix/${ID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return true
	},
	async approveRisk(ID) {
		if (isNaN(parseInt(ID))) {
			throw Error("ID must be a number")
		}
		let value = await api.put(`/riskapprove`, { id: ID })
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
}